import React, { useState } from 'react'
import CustomModal from 'cms/components/shared/CustomModal';
import { deleteItem } from 'cms/utils/Network';
import { getYoutubeId, isYoutube } from 'cms/utils';
import UrlEmbed from 'cms/components/UrlEmbed';
import VideoGalleryItemController from '../controller/VideoGalleryItemController';

export default function VideoGalleryItem({ item, showDelete = true, onDelete, onEdit }) {

    const { modalIsOpen, setModalIsOpen, _delete, _changeFeatured, is_featured } = VideoGalleryItemController(item,onDelete)

    return (
        <>

            <div key={item.id} className="talent-card-col">
                <div className="talent-card episode-gallery-card video-gallery-card">
                    {showDelete && onEdit && <EditButton />}
                    {showDelete && <DeleteButton />}
                    <button className="episode-gallery-card__open" onClick={() => { setModalIsOpen(true) }}>
                        <div className="episode-gallery-card__thumb-wrap">
                            {isYoutube(item.url) && (
                                <img
                                    src={`https://img.youtube.com/vi/${getYoutubeId(item.url)}/0.jpg`}
                                    className="episode-gallery-card__thumb"
                                    alt=""
                                />
                            )}
                            <span className="episode-gallery-card__play">
                                <i className="fa fa-play"></i>
                            </span>
                        </div>
                        {/* <div className="talent-card-name episode-gallery-card__title">
                            Video clip
                        </div>
                        <div className="talent-card-count episode-gallery-card__meta">
                            <i className="fa fa-calendar"></i>
                            <span>{item.created_at.split('T')[0]}</span>
                        </div> */}
                    </button>
                    <div className="video-gallery-card__actions">
                        <FeaturedButton />
                    </div>
                </div>
            </div>
            {modalIsOpen && (
                <CustomModal
                    isOpen={modalIsOpen}
                    setIsOpen={setModalIsOpen}
                >
                    <>
                        {(item && item.url != null && item.url !== "undefined") && <UrlEmbed url={item.url} />}
                    </>
                </CustomModal>
            )}

        </>

    );

    function DeleteButton() {
        return <div
            className="btn btn-default btn-sm cms-row-action-btn cms-row-action-btn-danger episode-gallery-card__delete"
            onClick={() => {
                if (window.confirm('Are you sure you wish to delete this item?'))
                    _delete();
            }}
        >
            <i className="fa fa-trash"></i>
        </div>;
    }

    function EditButton() {
        return <div
            className="btn btn-default btn-sm cms-row-action-btn episode-gallery-card__edit"
            title="Edit"
            onClick={() => onEdit()}
        >
            <i className="fa fa-edit"></i>
        </div>;
    }

    function FeaturedButton() {
        return <button
            type="button"
            className={`btn btn-default btn-sm cms-row-action-btn video-gallery-feature-btn ${is_featured ? 'color-gold' : 'color-white'}`}
            onClick={() => {

                _changeFeatured()
            }}
        >
            <i className="fa fa-star"></i>
        </button>;
    }
}


